var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-x-scroll scrollbar",attrs:{"id":`scroll-${_vm.id}`}},[_c('div',{staticClass:"tab-list-wrapper",attrs:{"id":_vm.id}},[_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index},[_c('tab-link',{style:({ width: `${_vm.tab_link_width}px` }),attrs:{"name":tab.name,"path":_vm.routes[index],"tab_index":index,"active_tab":_vm.active_tab},on:{"changeTab":function($event){return _vm.changeTab(index)}}})],1)}),_c('div',{staticClass:"active-line",style:({
				left: `${_vm.active_line_left_pos}px`,
				width: `${_vm.tab_link_width}px`,
			})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }